"use strict";

module.exports.Specification = require("./lib/specification");
module.exports.SpecificationSync = require("./lib/specification-sync");



//////////////////
// WEBPACK FOOTER
// ./~/specification/index.js
// module id = 182
// module chunks = 4 5